// #2 Brand lockup (DC-5): the GoToFoods mark straight on the nav canvas, GO TO in the text colour and the vertical
// FOODS in GoToFoods red, beside *Talent Acquisition Hiring Hub* (DC-229) behind a hairline. Variant "a" is the default;
// "tile" is the round-1 lockup (the mark in --on-red on a red tile, the GoToFoods wordmark above the title); "red"
// fills the whole mark red. The one path is drawn twice through two clip paths (left: GO TO, right: FOODS), whose
// ids come from useSvgId so url(#…) stays valid and unique per lockup. The mark is a logotype (WCAG 1.4.3 exempt).

import { MARK_PATH_D } from "../../shell/Logo";
import { cx } from "../lib/cx";
import { useSvgId } from "../lib/useSvgId";
import { SHELL_LABELS } from "./labels";

export type BrandVariant = "a" | "tile" | "red";

export interface BrandLockupProps {
  /** a (default) · tile · red. */
  variant?: BrandVariant | undefined;
  /** The 76 px rail form: the mark alone, centred (the title stays for assistive technology). */
  rail?: boolean | undefined;
  className?: string | undefined;
}

export function BrandLockup({ variant = "a", rail, className }: BrandLockupProps) {
  const id = useSvgId();
  const path = `${id}-p`;
  const left = `${id}-l`;
  const right = `${id}-r`;
  return (
    <div className={cx("mc-brand", variant !== "a" && `mc-brand-${variant}`, rail && "mc-brand-rail", className)}>
      <span className="mc-brand-mk">
        <svg role="img" aria-label={SHELL_LABELS.mark} viewBox="0 0 195.941 150.956" focusable="false">
          <defs>
            <clipPath id={left}><rect x="0" y="0" width="158" height="151" /></clipPath>
            <clipPath id={right}><rect x="158" y="0" width="38" height="151" /></clipPath>
            <path id={path} transform="translate(-21471 -15477.456)" d={MARK_PATH_D} />
          </defs>
          <use href={`#${path}`} className="mc-m-goto" clipPath={`url(#${left})`} />
          <use href={`#${path}`} className="mc-m-foods" clipPath={`url(#${right})`} />
        </svg>
      </span>
      <span className="mc-wm">
        <b aria-hidden="true">{SHELL_LABELS.mark}</b>
        <span>{SHELL_LABELS.brandTitle}</span>
      </span>
    </div>
  );
}
